// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Config from "../../../../../../Config.bs.js";
import * as CountryConfig from "../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as NetworkV2$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/NetworkV2.bs.js";
import * as BasicOrderRepoConfig from "./BasicOrderRepoConfig.bs.js";

function fetchBasicOrder(orderId, country) {
  var requestUrl = Config.Env.getHostName(undefined) + ("/administrators/ticketing/new?crn=" + orderId);
  return NetworkV2$Catalyst.get(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(BasicOrderRepoConfig.BasicOrderJsonResponseConverter.execute, result);
                        });
            });
}

var BasicOrderRepo = {
  fetchBasicOrder: fetchBasicOrder
};

export {
  BasicOrderRepo ,
  
}
/* Config Not a pure module */
